<template>
    <div class="box-border flex flex-col gap-2">
        <picture v-if="image" class="block aspect-square w-full rounded-lg object-cover">
            <source
                media="(min-width: 1024px)"
                :srcset="image.url + '?width=188&height=188&format=webp'" />
            <source
                media="(max-width: 1023px)"
                :srcset="image.url + '?width=446&height=446&format=webp'" />
            <img
                class="h-full w-full rounded-lg object-cover"
                :src="image.url + '?width=446&height=446&format=webp'"
                :alt="image.alt ?? ''"
                :title="image.title ?? undefined" />
        </picture>
        <h4 class="text-md text-brand-black font-semibold">{{ title }}</h4>
        <p class="text-brand-black m-0">{{ description }}</p>
    </div>
</template>

<script lang="ts" setup>
import type { TeamItemModel } from '@su4r-frontend/api';

const { description, image, title } = defineProps<TeamItemModel>();
</script>
